/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetExecuteRequest
 */
export interface ResetExecuteRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetExecuteRequest
     */
    password?: string;
}

export function ResetExecuteRequestFromJSON(json: any): ResetExecuteRequest {
    return ResetExecuteRequestFromJSONTyped(json, false);
}

export function ResetExecuteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetExecuteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function ResetExecuteRequestToJSON(value?: ResetExecuteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}


